import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCursor3"><Path d="M19.5 9.5L3 3L9.5 19.5L12.25 16.75L17 21.5L21.5 17L16.75 12.25L19.5 9.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCursor3;
